const areFilterArraysEmpty = values => {
  const { entityTypes, countries, relevanceTerms } = values;
  return [entityTypes, countries, relevanceTerms].every(arr => arr.length === 0);
};

export default { areFilterArraysEmpty };
